import React, { useEffect, useState } from "react";
import { Doughnut, PolarArea, } from "react-chartjs-2";
import annotationPlugin from "chartjs-plugin-annotation";
import { Chart as ChartJS, registerables } from "chart.js";
ChartJS.register(...registerables);
ChartJS.register(annotationPlugin);

const RadialChart = ({
    categories,
    selectedCat,
    topicID,
    handleChangeSelectedCategory,
    width,
    height,
    showTooltip
}) => {

    function duplicateArray(arr, times) {
    return Array.from({ length: times }, () => [...arr]).flat();
    }


    const data = {
        datasets: categories && categories.length ? duplicateArray(categories, 1)?.map((cat, index) => {
            return {
                label: cat.label ? cat.label : cat.name,
                key: cat.key,
                data: [cat.accuracyIndex, 100-cat.accuracyIndex],
                // hoverOffset: 10,
                borderWidth: 1,
                // borderWidth: cat.key === selectedCat?.key ? [2, 2] : [1, 1],
                // borderColor: cat.key === selectedCat?.key ? 'black' : 'white',
                backgroundColor: [cat.backgroundColor, "white"],
                // borderAlign:'inner',
                // borderRadius: showTooltip ? 1 : 10,
                circumference: (ctx) => {
                    return 270
                },
                
            }
        }) : []
    };

    const labelsRadialBar = {
        id: "labelsRadialBar",
        beforeDatasetsDraw(chart, args, pluginOptions) {
            const {ctx, data, scales} = chart;

            // ctx.font = 'bold 14px sans-serif';
            ctx.save();
            ctx.textAlign = 'left';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = 'black';

            // console.debug(chart.getDatasetMeta(0))

            for(let i = 0; i < data.datasets.length; i++) {
                const outerRadius = chart.getDatasetMeta(i).controller?.outerRadius;
                const innerRadius = chart.getDatasetMeta(i).controller?.innerRadius;
                if (outerRadius && innerRadius) {
                    const width = outerRadius - innerRadius;
                    const xPos = chart.getDatasetMeta(i).data[0].x;
                    const yPos = chart.getDatasetMeta(i).data[0].y;

                    if (selectedCat?.key === data.datasets[i].key) {
                        ctx.font = '14px sans-serif';
                    } else {
                        ctx.font = '14px sans-serif';
                    }
                    
                    ctx.fillText(` - ${data.datasets[i].label}`, xPos+4, yPos + innerRadius + (width/2));
                }
            }
            
        }
    }



    return (
        <div style={{
            position: 'relative',
            width: width ? width : '60px',
            height: height ? height : width
        }} >
            <Doughnut
                data={data}
                plugins={showTooltip ? [labelsRadialBar] : []}
                options={{
                    onClick: (event, chartElement, chart) => {
                        if (chartElement.length && categories?.length) {
                            console.debug("chartElement[0]", chartElement[0])
                        let catIndex = chartElement[0].datasetIndex;
                        let cat = categories[catIndex]
                        console.debug("cat", cat)
                        if (showTooltip && handleChangeSelectedCategory) {
                            handleChangeSelectedCategory(cat)
                        }
                        }
                        
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    cutout: categories.length >= 3 ? '40%' : '80%',
                    rotation: 180,
                    plugins: {
                        tooltip: {
                            enabled: showTooltip,
                            displayColors: true,
                            // callbacks: {
                            //     title: function (context) {
                            //         let index = context[0].datasetIndex;
                            //         let catName = categories[index].label ? categories[index].label : categories[index].name;
                            //         return catName
                            //     },
                            //     label: function (context) {
                            //         let index = context.datasetIndex;
                            //         let accuracyIndex = categories[index].accuracyIndex;
                            //         let timeInSec = categories[index].timeInSec;
                            //         return [` Accuracy Index: ${accuracyIndex}`, ` Time in Sec: ${timeInSec}`]
                            //     },
                            // },
                        },
                    }
                }}
            />
        </div>
    );
};

export default RadialChart;
